import { Injectable } from '@angular/core';
import {HttpClientService} from "./http-client.service";
import {AppConfigService} from "./app-config.service";

@Injectable()
export class ChangePasswordService {

  private apiUrl = AppConfigService.settings.apiUrl + 'users/';

  constructor(private http: HttpClientService) {
  }

  resetPassword(oldPass, newPass): Promise<any[]> {
    const body = new FormData();
    body.append('oldpass', oldPass);
    body.append('newpass', newPass);
    return this.http.post(this.apiUrl + 'resetpassword', body)
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/change-password.service.ts